import React from 'react'
import spinner from '../../utilities/pictures/spinner.gif'

const Spinner = () => {
    return (
        <div style={{marginTop:'4rem'}}>
            <img src={spinner} alt="" />
        </div>
    )
}

export default Spinner
